import { useQuery } from '@apollo/client';
import { convertBytes, getAttachmentType, getNameFromResponseTemplateKey } from 'helper/string.helper';
import { useEffect, useState } from 'react';
import { GET_FILE_URL } from 'schemas/query';
import CommonAttachmentMedia from 'views/pages/dashboard/KanbanQuestions/ModalBox/ViewEnquiryQuestionDetail/DetailContent/AttachmentInfo/CommonAttachmentMedia';
import CustomMediaPlay from 'views/pages/dashboard/KanbanQuestions/ModalBox/ViewEnquiryQuestionDetail/DetailContent/AttachmentInfo/CustomMediaPlayer';
import PdfAttachment from 'assets/images/icons/PdfAttachment.svg';
import CustomVideoPlayer from 'views/pages/dashboard/KanbanQuestions/ModalBox/ViewEnquiryQuestionDetail/DetailContent/AttachmentInfo/CustomVideoPlayer';
const AttachmentMediaUrl = ({ path, namePath, removeImage, sizeData, isFile, fileData, index, deleteImage, isNotDelete, isDownload }) => {
    const [url, setUrl] = useState('');
    const [size, setSize] = useState(0);
    const [name, setName] = useState(0);

    const { data } = useQuery(GET_FILE_URL, {
        fetchPolicy: 'cache-first',
        variables: {
            key: path
        },
        skip: !path
    });

    useEffect(() => {
        if (data) {
            setUrl(data?.getSignedUrlFromKey?.signedUrl || '');
            setSize(data?.getSignedUrlFromKey?.size || 0);
        }
    }, [data]);

    useEffect(() => {
        if (sizeData) {
            setSize(sizeData);
        }
        if (path) {
            setName(getNameFromResponseTemplateKey(path));
        } else {
            setName(namePath);
        }
    }, [sizeData]);
    const attachementType = getAttachmentType(path || namePath || '').toLowerCase();
    const attachementSize = convertBytes(size || 0);
    return attachementType === 'pdf' || attachementType === 'docx' ? (
        <CommonAttachmentMedia
            size={attachementSize}
            title={name}
            image={PdfAttachment}
            isImage={false}
            isFile={isFile}
            index={index}
            deleteImage={deleteImage}
            removeImage={removeImage}
            isDelete={!isNotDelete}
            downloadUrl={url}
            isDownload={isDownload}
        />
    ) : attachementType === 'png' || attachementType === 'jpg' || attachementType === 'jpeg' ? (
        <CommonAttachmentMedia
            size={attachementSize}
            title={name}
            image={!isFile ? url : URL.createObjectURL(fileData)}
            isImage={true}
            isFile={isFile}
            deleteImage={deleteImage}
            removeImage={removeImage}
            isDelete={!isNotDelete}
            index={index}
            downloadUrl={url}
            isDownload={isDownload}
        />
    ) : attachementType === 'mp3' || attachementType === 'mpga' || attachementType === 'mpeg' || attachementType === 'wav' ? (
        url || (isFile && fileData) ? (
            <CustomMediaPlay
                audioPlayer={!isFile ? url : URL.createObjectURL(fileData)}
                deleteImage={deleteImage}
                removeImage={removeImage}
                isDelete={!isNotDelete}
                isFile={isFile}
                index={index}
            />
        ) : null
    ) : attachementType === 'mp4' || attachementType === 'ogg' ? (
        url || (isFile && fileData) ? (
            <CustomVideoPlayer
                type={attachementType}
                videoPath={!isFile ? url : URL.createObjectURL(fileData)}
                deleteImage={deleteImage}
                removeImage={removeImage}
                isDelete={!isNotDelete}
                isFile={isFile}
                index={index}
            />
        ) : null
    ) : null;
};
export default AttachmentMediaUrl;
